function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getChartColor } from "../global";
import { StrokeCurveTypes, StrokeDashTypes } from "./";

// if needed: will generate values to create Best fit lines
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getBestFitValues = function getBestFitValues(values, categories) {
  return Array.from({
    length: categories.length
  }, function (_, i) {
    return Number((values[0] + i * ((values[1] - values[0]) / (categories.length - 1))).toFixed(2));
  });
};
var defaultChartDataObject = {
  color: getChartColor('blue-12'),
  dashStyle: StrokeDashTypes.solid,
  data: [],
  lineWidth: 2,
  name: '',
  pointPlacement: 'on',
  type: StrokeCurveTypes.smooth
};
export var createLineSeries = function createLineSeries(chartSeries, chartCategories) {
  var lineChartData = [];
  chartSeries === null || chartSeries === void 0 || chartSeries.map(function (item) {
    var lineProps = item.lineStrokeProps;
    var seriesData = item.data.length < chartCategories.length ? getBestFitValues(item.data, chartCategories) : item.data;
    var series = _objectSpread(_objectSpread({}, defaultChartDataObject), {}, {
      color: lineProps !== null && lineProps !== void 0 && lineProps.color ? getChartColor(lineProps.color) : defaultChartDataObject.color,
      dashStyle: lineProps !== null && lineProps !== void 0 && lineProps.dashType ? StrokeDashTypes[lineProps.dashType] : defaultChartDataObject.dashStyle,
      data: seriesData,
      lineWidth: lineProps !== null && lineProps !== void 0 && lineProps.width ? lineProps.width : defaultChartDataObject.lineWidth,
      name: item.name,
      type: lineProps !== null && lineProps !== void 0 && lineProps.curveType ? StrokeCurveTypes[lineProps.curveType] : defaultChartDataObject.type
    });
    lineChartData.push(series);
  });
  return lineChartData;
};